module.exports = __webpack_public_path__ + "img/care-offer-1.1162cd72.jpg";